import React from 'react';
import PropTypes from 'prop-types';
import './AppOpenButton.css';
import appLink from "../../util/appLink";
import {useLocation} from "react-router-dom";
import {useMounted} from "../../hook/useMounted";

export default function AppOpenButton({ hostname, userAgent }) {
    const location = useLocation();
    // hash는 서버가 알 수 없어 hydration mismatch를 유발하므로 mount 이후에만 반영
    const isMounted = useMounted();

    const path = location.pathname + location.search + (isMounted ? location.hash : '');
    const appLinkUrl = appLink(hostname, path, userAgent);

    return (
        <a className={'App-open-button-mobile'} href={appLinkUrl}>
            <div>앱 열기</div>
        </a>
    );
}

AppOpenButton.propTypes = {
    hostname: PropTypes.string.isRequired,
    userAgent: PropTypes.string.isRequired,
};